module.exports = __webpack_public_path__ + "img/00n.87cc2384.png";